/**
 * Detail routes for each console entity. Kept free of React and of the scope
 * provider so plain modules (recentItems, the header search) can import them.
 */
export const companyHref = (id: string) => `/companies/${id}`;
export const userHref = (oid: string) => `/users/${oid}`;
export const conferenceHref = (id: string) => `/conferences/${id}`;
export const leadHref = (id: string) => `/leads/${id}`;
